import React from "react";
import { Link } from "react-router-dom";
import { Phone, Printer, Mail, MapPin } from "lucide-react";
import mtstLogo from "../assets/img/mtst-logo.png";

const NAV_ITEMS = [
  { to: "/", label: "홈" },
  { to: "/technology", label: "기술 및 서비스" },
  { to: "/cases", label: "사례" },
  { to: "/introduction", label: "회사 소개" },
  { to: "/mission-vision", label: "미션 & 비전" },
  { to: "/careers", label: "채용" },
];

const CONTACT_ITEMS = [
  { icon: Phone, text: "031-342-5600", href: "tel:031-342-5600" },
  { icon: Printer, text: "FAX 031-624-5578" },
  { icon: Mail, text: "mtst@mtstech.kr", href: "mailto:mtst@mtstech.kr" },
];

const Footer = () => {
  return (
    <footer className="border-t border-gray-100 bg-gray-50">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {/* 로고 & 비전 */}
          <div className="sm:col-span-2 lg:col-span-2">
            <img src={mtstLogo} alt="MTST Logo" className="h-11 w-auto" />
            <p className="mt-5 max-w-sm break-keep text-sm leading-relaxed text-gray-600">
              스마트 제조 생태계의 글로벌 리더
              <br />
              MANUFACTURING DATA &amp; AI SOLUTION COMPANY
            </p>
          </div>

          {/* 바로가기 */}
          <div>
            <h3 className="text-sm font-semibold text-primary-900">
              바로가기
            </h3>
            <ul className="mt-4 space-y-3">
              {NAV_ITEMS.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-gray-600 transition-colors hover:text-primary-700"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold text-primary-900">
              Contact
            </h3>
            <ul className="mt-4 space-y-3 text-sm text-gray-600">
              {CONTACT_ITEMS.map(({ icon: Icon, text, href }) => (
                <li key={text} className="flex items-center gap-2">
                  <Icon className="h-4 w-4 shrink-0 text-primary-500" strokeWidth={1.75} />
                  {href ? (
                    <a href={href} className="transition-colors hover:text-primary-700">
                      {text}
                    </a>
                  ) : (
                    <span>{text}</span>
                  )}
                </li>
              ))}
              <li className="flex items-start gap-2">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-primary-500" strokeWidth={1.75} />
                <span className="break-keep">
                  경기도 군포시 군포첨단산업2로7번길 8, 지식산업센터동 835호
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* 하단 바 */}
        <div className="mt-12 border-t border-gray-200 pt-6 text-sm text-gray-500">
          <p>MTST Co., Ltd. All Rights Reserved. 주식회사 엠티에스티</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
